module.exports = __webpack_public_path__ + "img/icon-tarjetas-outline.bfab5e12.svg";